export type SeasonalDecoration = 'christmas' | 'easter' | null;

const getEasterSunday = (year: number): Date => {
    const a = year % 19;
    const b = Math.floor(year / 100);
    const c = year % 100;
    const d = Math.floor(b / 4);
    const e = b % 4;
    const f = Math.floor((b + 8) / 25);
    const g = Math.floor((b - f + 1) / 3);
    const h = (19 * a + b - d - g + 15) % 30;
    const i = Math.floor(c / 4);
    const k = c % 4;
    const l = (32 + 2 * e + 2 * i - h - k) % 7;
    const m = Math.floor((a + 11 * h + 22 * l) / 451);
    const month = Math.floor((h + l - 7 * m + 114) / 31);
    const day = ((h + l - 7 * m + 114) % 31) + 1;

    return new Date(year, month - 1, day);
};

const normalizeDate = (date: Date) =>
    new Date(date.getFullYear(), date.getMonth(), date.getDate()).getTime();

export const isEasterTime = (today: Date = new Date()): boolean => {
    const month = today.getMonth();
    if (month < 2 || month > 3) return false;

    const easterSunday = getEasterSunday(today.getFullYear());
    const palmSunday = new Date(easterSunday);
    palmSunday.setDate(palmSunday.getDate() - 7);

    const easterMonday = new Date(easterSunday);
    easterMonday.setDate(easterMonday.getDate() + 1);

    const todayTime = normalizeDate(today);
    return (
        todayTime >= normalizeDate(palmSunday) && todayTime <= normalizeDate(easterMonday)
    );
};

export const getSeasonalDecoration = (today: Date = new Date()): SeasonalDecoration => {
    if (today.getMonth() === 11) return 'christmas';
    if (isEasterTime(today)) return 'easter';

    return null;
};
